import React from "react";
import { GiCartwheel } from "react-icons/gi";
import { Link } from "react-router-dom";
import { SaveOnParts } from "../../SaveOnParts/SaveOnParts";
import "./AdvancedService.css";

const AdvancedService = () => {
	return (
		<div className="services-Page">
			<main className="services-Page-main">
				<SaveOnParts />

				<section className="Page-main__content">
					<h1 className="Page-main__content-mainTitle">
						Advanced Services-£95
					</h1>
					<p className="Page-main__content--paragraph">
							Recommended for anyone who’s bike is showing obvious running
							problems / noises, or has not been serviced for 8 months or more.
						<br></br>
							The advanced service incorporates the standard service.In addition
							all cable, brake pad, tyre, chain/cassette fitting and drivetrain
							clean and re-lube are included by default.
						<br></br>
						<br></br>

						<b> Plus any two single jobs from the following list:</b>
					</p>

					<ul className= "Page-main__content--paragraph">
						<li><GiCartwheel/>
							Standard hub service (new axle cones and bearings included) sealed bearings extra.
						</li>
						<li><GiCartwheel/>
							Headset service (Bearings cleaned, re-greased, or replacement)
						</li>
						<li><GiCartwheel/>
							Bottom Bracket service (new bearings/grease or replacement)
						</li>
						<li><GiCartwheel/>
							Spoke replace and wheel true.
						</li>
					</ul>

					<button className="Page-main__content--Button"  style={{alignSelf:"center"}}>
						<Link to="/Booking">Book Now</Link>
					</button>
				</section>
				
			</main>
			 

			 

		</div>
	);
};

export default AdvancedService;
